import { ClientStatus, StatusCategory, GroupedClients } from '../types'
import { Account } from '@/common/types'
import { NAVIGATION_COPY } from '@/locales/en'
import { getClientStatus } from './getClientStatus'

const actionRequiredStatuses: ClientStatus[] = [ClientStatus.KYC_IN_PROGRESS, ClientStatus.CONFIRMATION_FAILED]

const inProgressStatuses: ClientStatus[] = [ClientStatus.CLIENT_CONFIRMATION, ClientStatus.ACCOUNT_PROCESSING]

export function groupClientsByStatus(clients: Account[]): GroupedClients[] {
    const actionRequired: Account[] = []
    const inProgress: Account[] = []

    for (const client of clients) {
        const status = getClientStatus(client.accountStatus)
        if (!status) continue

        if (actionRequiredStatuses.includes(status)) {
            actionRequired.push(client)
        } else if (inProgressStatuses.includes(status)) {
            inProgress.push(client)
        }
    }

    const groups: GroupedClients[] = []

    if (actionRequired.length > 0) {
        groups.push({
            category: StatusCategory.ACTION_REQUIRED,
            categoryLabel: NAVIGATION_COPY.adviserClients.inProgress.actionRequired,
            count: actionRequired.length,
            clients: actionRequired,
        })
    }

    if (inProgress.length > 0) {
        groups.push({
            category: StatusCategory.IN_PROGRESS,
            categoryLabel: NAVIGATION_COPY.adviserClients.inProgress.inProgressLabel,
            count: inProgress.length,
            clients: inProgress,
        })
    }

    return groups
}
